import React from 'react';
import styles from './DashboardBox.module.scss';
import { FiInfo } from 'react-icons/fi';
import Tooltip from "../Tooltip/Tooltip";
import { IoOpenOutline, IoTriangleSharp } from 'react-icons/io5';
import { Link } from 'react-router-dom';


class DashboardBox extends React.Component {
    // constructor(props) {
    //     super(props);
    // }
    //
    // componentDidMount() {
    //     // console.log('DashboardBox', this.props);
    // }

    render() {
        return (
            <div className={ styles.container } style={ this.props.style }>
                <div className={ styles.headerRow } style={ this.props.headerStyle }>
                    {
                        this.props.info ?
                            <div className={ styles.infoContainer }>
                                <Tooltip content={ this.props.info }>
                                    <FiInfo className={ styles.infoIcon } />
                                </Tooltip>
                            </div>
                            :
                            null
                    }
                    <div className={ styles.header }>
                        { this.props.header }
                    </div>
                    <div className={ styles.headerLink }>
                        { this.props.link &&
                            <Tooltip content={ this.props.link.title }>
                                <Link to={ this.props.link.to }>
                                    <IoOpenOutline className={ styles[ 'info-icon' ] } style={ {
                                        cursor: 'pointer',
                                        color: '#111',
                                        width: '22px',
                                        height: '22px',
                                    } } />
                                </Link>
                            </Tooltip>
                        }
                        { this.props.sideComponent && <div className={ styles.headerSideComponent }>{ this.props.sideComponent }</div> }
                    </div>
                </div>
                <div className={ `${styles.contentContainer}` } style={ { height: '100%', ...this.props.contentStyle } }>
                    { this.props.children }
                </div>
            </div>
        );
    }
}

export default DashboardBox;
